import { render, staticRenderFns } from "./CreateTextFile.vue?vue&type=template&id=298dc9f1"
import script from "./CreateTextFile.vue?vue&type=script&lang=js"
export * from "./CreateTextFile.vue?vue&type=script&lang=js"
import style0 from "./CreateTextFile.vue?vue&type=style&index=0&id=298dc9f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports